export const RESTAURANT_SELECT_LIMIT = 50;
export const KEY_ACCOUNT_GROUP_SELECT_LIMIT = 5;
